import React from 'react';

const Modal = ({ aberto, setAberto, titulo, children, opcaoFechar = true }) => {
  React.useEffect(() => {
    if (aberto) {
      document.body.addEventListener('keydown', listener);
    } else {
      document.body.removeEventListener('keydown', listener);
    }
  }, [aberto]);

  var listener = function (event) {
    if (event.key === 'Escape') {
      setAberto(false);
    }
  };

  return (
    <div
      className={`modal ${aberto && 'aberto'}`}
      id="modal-pesquisa"
      data-esc=""
    >
      <section>
        <header>
          <h2> {titulo}</h2>
          {opcaoFechar && (
            <a className="fechar" onClick={() => setAberto(false)}></a>
          )}
        </header>
        {children}
      </section>
    </div>
  );
};
export default Modal;
